export function shouldRenderReactQueryDevtools(
	envName: string | undefined
): boolean {
	return envName !== 'production'
}
